<template>
  <div>
    <PageMain
      ref="main"
      :loading="loading"
      :tableData="tableData"
      :disabled="disabled"
      @reload="getData()"
      @openEdit="openEdit"
      @del="del"
    >
      <template #header>
        <div class="d-flex align-items-stretch">
          <div class="side-frame-success"></div>
          <div class="d-flex align-items-center">
            <span style="font-size: 14px; color: #606266">
              {{ $l('table_header_category') || '客户品类' }}
            </span>
            <el-divider direction="vertical" v-if="!disabled" />
            <b-button
              v-if="!disabled"
              size="sm"
              class="ml-2"
              variant="outline-success"
              @click="openEdit({ type: 'add' })"
            >
              {{ $l('btn_addCategory') || '新增品类' }}
            </b-button>
          </div>
        </div>
      </template>
    </PageMain>

    <EditForm
      :visible.sync="editFormOpts.visible"
      :type="editFormOpts.type"
      :custCategoryCode="editFormOpts.custCategoryCode"
      :custCode="custCode"
      @reload="getData()"
    />
  </div>
</template>
<script>
import PageMain from './main'
import EditForm from './components/edit-form'
import EditLoading from '@/mixins/edit-loading'
export default {
  components: { PageMain, EditForm },
  mixins: [EditLoading],
  props: {
    custCode: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      tableData: [],
      loading: false,
      editFormOpts: { visible: false, type: '', custCategoryCode: '' },
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      this.loading = true
      const res = await this.$api
        .masterCustomerCategoryListApi({ custCode: this.custCode })
        .catch(() => null)
      this.loading = false
      this.tableData = res?.body?.data || []
    },
    openEdit({ type, row: { custCategoryCode = '' } = {} } = {}) {
      this.editFormOpts = { visible: true, type, custCategoryCode }
    },
    async del({ custCategoryCode }) {
      const confirm = await this.$confirm(
        this.$l('INDEX.tips_delete') || '是否要删除该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText: this.$l('INDEX.btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return
      if (this.loadingOpen()) return
      const res = await this.$api
        .masterCustomerCategoryDelApi({ custCategoryCode })
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_delete_no') || '删除失败！')
        return
      }
      this.$message({
        message: this.$l('INDEX.tips_delete_ok') || '删除成功！',
        type: 'success',
      })
      this.getData()
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame-success {
  padding: 1px 5px;
  margin-top: 3px;
  margin-bottom: 3px;
}
</style>
